import { configureStore } from "@reduxjs/toolkit";
import Reducercode from "./reducer.js";

export default configureStore({
  reducer: Reducercode,
});
